export const dataStartDateTime = {
  type: 'string',
  minLength: 1,
};
